<template>
  <div class="container">
    <img src="@/assets/images/404.jpg" width="700" />
    <a href="javascript:history.back()"></a>
  </div>
</template>

<script>
export default {
  name: "404",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.container {
  margin-top:30px; 
  text-align: center;
  width: 700px;
  height: 500px;
  overflow: hidden;
  margin: 30px auto;
  position: relative;
  a {
    display: block;
    position: absolute;
    bottom: 37px;
    left: 340px;
    width: 112px;
    height: 32px;
  }
}
</style>
